import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bulk-activation-confirm',
  templateUrl: './bulk-activation-confirm.component.html',
  styleUrls: ['./bulk-activation-confirm.component.scss']
})
export class BulkActivationConfirmComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<BulkActivationConfirmComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) { }

  ngOnInit(): void {
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

}
